import React, { useState, useEffect } from "react";

import VerifiedOfficers from "./verifiedOfficers";
import DashboardSidebar from "../agencyDashboardSidebar";
import { ReactComponent as SendUp } from "../../../_asset/img/send_up.svg";
import { ReactComponent as SearchIcon } from "../../../_asset/img/search-normal.svg";
import InviteOfficer from "./officerinvite";
import { Link, useParams, useHistory } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useProviderCompany } from "../../../../context/ProviderCompanyContext";
import {
  getCustomerCompanies,
  getTeamResources,
  inviteUserAsProviderResource,
} from "../../../../services/staffingService";

const Officers = () => {
  const { userInfo, userInfoReady } = useUser();
  const { providerCompanyId } = useParams();
  const { providerCompanyData, fetchProviderCompanyData } =
    useProviderCompany();
  const [officers, setOfficers] = useState([]);
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [areFiltersActive, setAreFiltersActive] = useState(false); // State to track if filters are active

  const [filters, setFilters] = useState({
    searchText: "",
    officerName: null,
    city: null,
    state: null,
    email: null,
    hasSLA: false, // This will filter if the company has an SLA
  });

  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchOfficers();
  }, [providerCompanyId]);

  const fetchOfficers = async () => {
    const resp = await getTeamResources(providerCompanyId);
    setOfficers([...resp.data.providerResources]);
    setFilteredOfficers([...resp.data.providerResources]);
  };

  const handleClose = () => {
    console.log("close officer invite tab");
    setOpen(false);
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
    //resetFilters();
  };

  const getUniqueOptions = (key) => {
    const keys = key.split(",");
    return Array.from(
      new Set(
        officers.map((item) => {
          if (keys.length === 2) {
            return `${item[keys[0]]} ${item[keys[1]]}`; // Combine firstName and lastName
          }
          const nestedKeys = key.split("."); // Support nested keys
          return nestedKeys.reduce((acc, curr) => acc && acc[curr], item); // Access nested properties
        })
      )
    ).map((value) => ({
      label: value || "N/A",
      value: value || "N/A",
    }));
  };


  const applyFilters = () => {
    const filtered = officers.filter((item) => {
      // Check if search text matches officer's name or email
      const matchesSearchText =
        filters.searchText === "" || // If searchText is empty, match all officers
        `${item.user_id?.firstName || ""} ${item.user_id?.lastName || ""}`
          .toLowerCase()
          .includes(filters.searchText.toLowerCase()) || // Check firstName + lastName
        item.user_id?.email
          ?.toLowerCase()
          .includes(filters.searchText.toLowerCase()); // Check email if user_id exists

      // Match officer name (firstName + lastName)
      const matchesOfficerName =
        !filters.officerName ||
        `${item.user_id?.firstName || ""} ${item.user_id?.lastName || ""}`.toLowerCase() ===
          filters.officerName.toLowerCase();

      // Match city from address
      
      const matchesCity =
        !filters.city ||
        item.address?.city?.toLowerCase() === filters.city.toLowerCase();

      // Match state from address
      const matchesState =
        !filters.state ||
        item.address?.state?.toLowerCase() === filters.state.toLowerCase();

      // Match email (nested in user_id.email)
      const matchesEmail =
        !filters.email || item.user_id?.email === filters.email;

      return (
        matchesSearchText &&
        matchesOfficerName &&
        matchesCity &&
        matchesState &&
        matchesEmail
      );
    });

    setFilteredOfficers(filtered); // Update the filtered officers
    const activeFilters = checkIfFiltersAreActive(); // Check if filters are active
    setAreFiltersActive(activeFilters); // Update state if filters are active
  };

  const checkIfFiltersAreActive = () => {
    return (
      filters.searchText !== "" || 
      filters.officerName !== null || 
      filters.city !== null || 
      filters.state !== null || 
      filters.email !== null || 
      filters.hasSLA !== false 
    );
  };

  const resetFilters = () => {
    setFilters({
      searchText: "", 
      officerName: null, 
      city: null, 
      state: null, 
      email: null, 
      hasSLA: false,
    });
    
    setFilteredOfficers(officers); // Reset to original data
    setAreFiltersActive(false); // Reset the active filters state
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
      <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
      <main className="flex-1 overflow-hidden">

        <div className="font-inter bg-gradient-to-b from-[#D7E1FF] via-[#EEF1FA] to-white h-full overflow-hidden">
          <div className="flex items-center justify-between p-6 bg-white border-b border-[#E4E4E4]">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-1">Officers</h2>
              <p className="text-gray-600">Manage all of the officers that you have</p>
            </div>
            <div className="flex items-center gap-4">
              <a href="/partner-success" target="_blank">
                <button className="flex items-center gap-2 px-2 py-2 text-black font-semibold border border-[#E0E0E0] bg-white rounded-lg hover:bg-gray-50 transition-colors">
                  <span className="w-8 h-8 bg-[#E8FEE6] text-[#15B707] text-xs font-semibold rounded-full flex items-center justify-center">
                    184
                  </span>
                  Officers Around You
                  <SendUp />
                </button>
              </a>

              <button
                className="px-4 py-3 bg-[#404880] text-white font-semibold rounded-lg hover:bg-[#363e70] transition-colors"
                onClick={() => setOpen(true)}
              >
                + Invite Officer
              </button>
            </div>
          </div>

          <div className="flex gap-6 p-6 h-[calc(100vh-197px)] overflow-y-auto pb-8" id="scrollBar">
            <div className="w-[304px] bg-white rounded-lg shadow-lg p-4 h-fit sticky top-0">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Filter</h2>
              </div>
              
              <div className="relative mb-4">
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <SearchIcon />
                </div>
                <input
                  type="text"
                  className="form-input form-input-with-icon"
                  placeholder="Search officers"
                  value={filters.searchText}
                  onChange={(e) =>
                    handleFilterChange("searchText", e.target.value)
                  }
                />
              </div>
              
              <div className="space-y-2 mb-4">
                <select
                  className="form-select"
                  value={filters.email || ''} 
                  onChange={(e) =>
                    handleFilterChange("email", e.target.value || null)
                  }
                >
                  <option value="">Email</option>
                  {getUniqueOptions("user_id.email").map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <select
                  className="form-select"
                  value={filters.city || ''} 
                  onChange={(e) => handleFilterChange("city", e.target.value || null)}
                >
                  <option value="">City</option>
                  {getUniqueOptions("address.city").map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <select
                  className="form-select"
                  value={filters.state || ''} 
                  onChange={(e) =>
                    handleFilterChange("state", e.target.value || null)
                  }
                >
                  <option value="">State</option>
                  {getUniqueOptions("address.state").map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-6">
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#404880] focus:ring-offset-2 ${
                      filters.hasSLA ? 'bg-[#404880]' : 'bg-[#B6B9CF]'
                    }`}
                    onClick={() => handleFilterChange("hasSLA", !filters.hasSLA)}
                    role="switch"
                    aria-checked={filters.hasSLA}
                  >
                    <span
                      aria-hidden="true"
                      className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                        filters.hasSLA ? 'translate-x-5' : 'translate-x-0'
                      }`}
                    />
                  </button>
                  <span className="text-sm text-[#616161]">Has SLA</span>
                </div>
              </div>
              
              <div>
                {!areFiltersActive && (
                  <button 
                    className="w-full bg-[#404880] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#363e70] transition-colors"
                    onClick={applyFilters}
                  >
                    Apply
                  </button>
                )}
                {areFiltersActive && (
                  <div className="flex items-center justify-between">
                    <button 
                      className="text-sm text-gray-500 hover:text-[#404880] transition-colors underline cursor-pointer"
                      onClick={resetFilters}
                    >
                      Reset Filters
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="w-[calc(100%-328px)]">
              <VerifiedOfficers
                officers={officers}
                filteredOfficers={filteredOfficers}
                setOfficers={setOfficers}
                setFilteredOfficers={setFilteredOfficers}
                providerCompanyId={providerCompanyId}
              />
            </div>
          </div>
        </div>
      </main>

      <InviteOfficer open={open} setOpen={setOpen}  handleClose={handleClose} providerCompanyId={providerCompanyId} />

    </div>
  );
};

export default Officers;
